import { gql } from '@apollo/client';

export const DELETE_GOAL = gql`
  mutation DeleteGoal($goalId: Int!) {
    delete_goals_by_pk(id: $goalId) {
      id
    }
  }
`;

export const INSERT_GOAL = gql`
  mutation InsertGoal($goal: goals_insert_input!) {
    insert_goals_one(object: $goal) {
      en
      gameId
      goal
      gw
      id
      period
      pp
      primaryAssist
      seasonId
      secondaryAssist
      sh
      teamId
      time
    }
  }
`;
